import { API_BASE_URL } from "../../config";
import React, { useState, useEffect } from 'react';

const LoadCellManager = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [hwidFilter, setHwidFilter] = useState("");
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

    const API_BASE = `${API_BASE_URL}/hwcontrol/api/LoadCellData`;

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            const token = user?.token;

            // Construct URL with filters
            let url = `${API_BASE}?startDate=${selectedDate}&endDate=${selectedDate}`;
            if (hwidFilter) {
                url += `&HWID=${hwidFilter}`;
            }

            const resp = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                }
            });

            if (resp.ok) {
                let result = await resp.json();
                
                // Sort by date and time (newer first) as requested by API description
                // and then by HWID as requested by the issue
                result.sort((a, b) => {
                    const dateTimeA = new Date(`${a.date}T${a.time}`);
                    const dateTimeB = new Date(`${b.date}T${b.time}`);
                    if (dateTimeB - dateTimeA !== 0) {
                        return dateTimeB - dateTimeA;
                    }
                    return a.hwid.localeCompare(b.hwid);
                });

                setData(result);
            } else {
                setError(`Failed to fetch data: ${resp.status}`);
            }
        } catch (err) {
            setError(`Error: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [selectedDate]);

    const handleSearch = (e) => {
        e.preventDefault();
        fetchData();
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>LoadCell Data Management</h2>
            
            <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                <div>
                    <label>Select Date:</label><br/>
                    <input 
                        type="date" 
                        value={selectedDate} 
                        onChange={(e) => setSelectedDate(e.target.value)}
                        className="form-control"
                    />
                </div>
                <div>
                    <label>HWID:</label><br/>
                    <input 
                        type="text" 
                        value={hwidFilter} 
                        onChange={(e) => setHwidFilter(e.target.value)}
                        placeholder="Filter by HWID"
                        className="form-control"
                    />
                </div>
                <button 
                    onClick={handleSearch} 
                    className="btn btn-primary"
                    disabled={loading}
                >
                    {loading ? 'Loading...' : 'Search'}
                </button>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="table-responsive">
                <table className="table table-striped table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th>ID</th>
                            <th>HWID</th>
                            <th>Weight Add</th>
                            <th>Weight Now</th>
                            <th>Date</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>{item.hwid}</td>
                                    <td>{item.weight_Add?.toFixed(2)}</td>
                                    <td>{item.weight_now?.toFixed(2)}</td>
                                    <td>{item.date}</td>
                                    <td>{item.time}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: 'center' }}>No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LoadCellManager;
